import React, { useEffect } from 'react'
import { useTracking } from 'react-tracking'
import { faPhone, faTimes } from '@fortawesome/free-solid-svg-icons'

import Button from '../Button/Button'
import IconButton from '../Button/IconButton'
import Link from '../Link'
import Icon from '../Icon'

import { toTelephoneHref } from '../../helpers'

const microConversion = {
  category: 'Micro-Conversion',
  event: 'Reveal Phone Number',
}

const conversion = {
  category: 'Conversion',
  event: 'Click to Call',
}

const PhoneButton = ({ phone, show, onClick }) => {
  const tracking = useTracking()

  useEffect(() => {
    if (show) tracking.trackEvent({ label: phone, ...microConversion })
  }, [show, phone, tracking])

  return onClick ? (
    show ? (
      <Button type='gray300' as='span' style={{ position: 'relative' }}>
        <Link href={toTelephoneHref(phone)} trackingData={conversion}>
          {phone}
        </Link>
        <Icon
          icon={faTimes}
          fixedWidth
          onClick={onClick}
          style={{ position: 'absolute', right: 10 }}
        />
      </Button>
    ) : (
      <IconButton type='gray300' onClick={onClick}>
        <Icon icon={faPhone} fixedWidth />
      </IconButton>
    )
  ) : (
    <IconButton type='gray300' as={Link} href={toTelephoneHref(phone)} trackingData={conversion}>
      <Icon icon={faPhone} fixedWidth />
    </IconButton>
  )
}

export default PhoneButton
